<div mat-dialog-content style="height: 100%; margin: auto" class="container">

  <div class="row" style="width: 100%; margin: 2% 0 0;">
    <label for="files" style="margin: auto;" class="btn buttonCst textS+">{{this.localiser.get('select_floorplans.addFloorplan')}}</label>
    <input id="files" style="display: none;" type="file" (change)="onSelectFile($event)"
           accept=".svg,image/svg+xml">
    <div *ngIf="fileError" style="color: red; font-weight: bold">
      {{ fileError }}
    </div>
  </div>
  <div class="row">

    <h3 style="margin: auto; text-align: center" *ngIf="selectedFile != null" class="textXS">
      <span class="material-icons-outlined textXS">
      check
    </span>
      {{this.nameOriginalFile}}
    </h3>
  </div>
  <div class="row" style="margin: 2% 0">
    <div class="col">
      <div class="row inputNameRow">
        <h3 class="textS+">{{this.localiser.get('select_floorplans.name')}}</h3>
      </div>
      <div class="row inputNameRow">
      <input id="nameFileInput" [disabled]="selectedFile == null" [(ngModel)]="nameFile" placeholder="{{this.localiser.get('select_floorplans.name')}}"
             type="text" class="inputText textS+" [ngClass]="{'nameFileRed': nameFileEmpty}" (input)="changeFileName()" maxlength="255"
              style="margin: auto">
      </div>
    </div>
  </div>
  <div class="row" style="margin: 2% 0">
    <div class="col">
      <div class="row inputNameRow">
        <h3 class="textS+">{{this.localiser.get('select_floorplans.description')}}</h3>
      </div>
      <div class="row inputNameRow">
        <textarea [disabled]="selectedFile == null" [(ngModel)]="descriptionFile" placeholder="{{this.localiser.get('select_floorplans.description')}}"
                  type="text" class="inputText textS+" maxlength="300" style="margin: auto"></textarea>
      </div>
    </div>
  </div>
  <div class="row" style="margin: 3% auto; width: 80%">
    <div class="col" style="margin: auto; border-right: 1px solid white;">
      <div class="row" style="margin: auto">
        <h3 class="textS+">Longitud del eje X del plano en metros</h3>
      </div>
      <div class="row">
        <div class="col">
          <input [disabled]="selectedFile == null" [(ngModel)]="metrosPlano" placeholder="Metros"
             type="number" class="inputText textS+" maxlength="10"
             style="margin: auto">
        </div>
        <div class="col" style="margin: auto">
          <h3 class="textS+" style="margin: auto">Metros</h3>
        </div>
      </div>
    </div>
    <div class="col" style="margin: auto">
      <div class="row" style="margin: auto">
        <h3 class="textS+">Escala de las luminarias para mostrarlas sobre el plano</h3>
      </div>
      <div class="row">
        <div class="col-3" style="margin: auto; text-align: right">
          <h3 class="textS+" style="margin: auto">1:</h3>
        </div>
        <div class="col">
          <input [disabled]="selectedFile == null" [(ngModel)]="escalaLuminarias" placeholder="Escala"
                 type="number" class="inputEscala textS+" maxlength="3"
                 style="margin: auto">
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button
              (click)="onCancelClick()">{{this.localiser.get('select_floorplans.exit')}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button [disabled]="selectedFile == null || nameFileEmpty || escalaLuminarias <= 0 || metrosPlano <= 0" class="customButtonColorReverse textS" mat-button
              style="border: 1px solid white" (click)="performUpload()">{{this.localiser.get('select_floorplans.upload')}}</button>
    </div>
  </div>

</div>
